// extracted by mini-css-extract-plugin
module.exports = {"companyLogoWrapper":"styles_companyLogoWrapper__2HG37"};